import React from 'react'
import Loader from 'components/Loader'
import styled from 'styled-components'
import { toWidth } from 'helpers'
import AspectRatioImage, { AspectRatioImageContainer } from 'components/AspectRatioImage'

export default ({ photo, loading, onClick }) => {
  if (photo.imagePath && !loading) {
    return <AspectRatioImage src={toWidth(photo.imagePath, 300)} onClick={onClick} />
  }
  return <Loader />
}

export const PhotoItemWrapper = styled(AspectRatioImageContainer)`
  margin-right: 5px;
  margin-bottom: 5px;

  display: inline-block;
  vertical-align: top;
  position: relative;
  cursor: pointer;
  transition: opacity 0.3s ease;
  &:hover { opacity: 0.8; }
  @media(min-width: 960px) {
    margin-right: 10px;
    width: calc(16.67% - 8.36px);
    padding-bottom: calc(16.67% - 8.36px);
    &:nth-child(6n) {
      margin-right: 0px;
      ${props => props.limit && `
        &:after {
          content: 'ดูทั้งหมด';
          color: white;
          background-color: rgba(0, 0, 0, 0.8);
          position: absolute;
          top: 0px;
          left: 0px;
          right: 0px;
          bottom: 10px;
          z-index: 1;
          text-align: center;
          line-height: 30px;
          padding-top: calc(50% - 15px);
          cursor: pointer;
        }
        > div > div:nth-child(n+2) { display: none; }
      `}
    }
    &:nth-child(n+7) { display: none; }
  }
  @media(min-width: 768px) and (max-width: 959px) {
    margin-right: 10px;
    width: calc(20% - 8px);
    padding-bottom: calc(20% - 8px);
    &:nth-child(5) {
      margin-right: 0px;
      &:after {
        content: '';
        background-color: rgba(0, 0, 0, 0.5);
        position: absolute;
        top: 0px;
        left: 0px;
        right: 0px;
        bottom: 0px;
      }
      > div > div:nth-child(n+2) { display: none; }
    }
    &:nth-child(n+6) { display: none; }
  }
  @media(min-width: 600px) and (max-width: 767px) {
    ${props => props.desktop && 'display: none;'}
    margin-right: 5px;
    width: calc(25% - 3.75px);
    padding-bottom: calc(25% - 3.75px);
    &:nth-child(4n) { margin-right: 0px; }
  }
  @media(max-width: 599px) {
    ${props => props.desktop && 'display: none;'}
    margin-right: 5px;
    width: calc(33.33% - 4px);
    padding-bottom: calc(33.33% - 4px);
    &:nth-child(3n) { margin-right: 0px; }
  }
`



// WEBPACK FOOTER //
// ./src/components/PhotoItem.js